module.exports = __webpack_public_path__ + "0cac0b830a78865672f4d08c971d7fb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/32.jpg
// module id = 1360
// module chunks = 47